import React, { Component } from 'react';
import './index.css';
import { OSULoading, Body1, OSUError } from 'osu-react-components'
import queryString from 'query-string'
import {PAGE_TITLE_POSTFIX} from "../../constants";

class ViewPdf extends Component {
    constructor(props) {
        super(props);
        let isiPad = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        console.log("isIpad: " + isiPad);
        console.log("navigator.platform: " + navigator.platform);
        console.log("maxTouchPoints: " + navigator.maxTouchPoints);
        this.state = {
            pageTitle: "PDF Document Viewer",
            isiPad: isiPad,
            data: null
        };
    }

    // Helper function for Base64URL decoding
    base64UrlDecode(str) {
        if (!str) return '';
        // Convert Base64URL to Base64
        let base64 = str
            .replace(/-/g, '+')
            .replace(/_/g, '/');
        // Add padding
        while (base64.length % 4) {
            base64 += '=';
        }
        try {
            return atob(base64);
        } catch (e) {
            console.error('Failed to decode base64:', e);
            return str; // Return original if decode fails
        }
    }

    componentWillMount() {
        document.title = this.state.pageTitle + PAGE_TITLE_POSTFIX;
    }

    componentDidMount = () => {
        let awardPk = this.props.defaultAwardPk
        const params = queryString.parse(this.props.location.search);
        const awardPkOverride = params.awardPK;
        if(awardPkOverride) {            
            awardPk = awardPkOverride
        }

        // Decode Base64URL encoded name
        const decodedName = this.base64UrlDecode(params.name);

        this.props.setA11yMessage(`Navigated to the ${this.state.pageTitle} page`);
        this.pageContent.focus();
        this.props.getViewDocument(this.props.match.params.id, decodedName, awardPk);
    };
    
    componentDidUpdate() {
        if(this.props.viewDocument.url && this.state.isiPad) {
            window.location.assign(this.props.viewDocument.url)
        }
    }

    render() {
        const params = queryString.parse(this.props.location.search);
        const decodedName = this.base64UrlDecode(params.name);
        const decodedPlan = this.base64UrlDecode(params.plan);
        
        if(this.state.isiPad === false) {
            return (
                <div ref={(el) => { this.pageContent = el; }} tabIndex="-1" aria-label={this.state.pageTitle} className="viewPdf">
                    {this.props.viewDocumentIsError && <OSUError ariaLabel="Error occurred. Reload pdf document." text="Could not fetch pdf document." actionText="Retry" onClick={() => this.props.getViewDocument(this.props.match.params.id, decodedName, params.awardPK)} />}
                    {this.props.viewDocumentIsLoading && <OSULoading text="Loading Document.... This might take a minute. "></OSULoading>}
                    {!this.props.viewDocumentIsLoading && <div>
                        <Body1><strong>Nominee:</strong> {decodedName}
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            &nbsp;
                    <strong>Academic Plan</strong>: {decodedPlan}</Body1>
                        {this.props.viewDocument && <iframe title="PDF Viewer" id="pdfViewer" src={this.props.viewDocument.url} className="viewer" ></iframe>}
                    </div>}
                </div>
            );
                    }
                    else {
                        return (<div ref={(el) => { this.pageContent = el; }} tabIndex="-1" aria-label={this.state.pageTitle} className="viewPdf" >
                            {this.props.viewDocumentIsError && <OSUError ariaLabel="Error occurred. Reload pdf document." text="Could not fetch pdf document." actionText="Retry" onClick={() => this.props.getViewDocument(this.props.match.params.id, decodedName, params.awardPK)} />}
                            {this.props.viewDocumentIsLoading && <OSULoading text="Loading Document.... This might take a minute. "></OSULoading>}</div>);
                    }
        }
}

export default ViewPdf;
